import type { Dict } from './en';

export const it: Dict = {
  appTagline: 'Tracker di voli in tempo reale, aperto',
  search: 'Cerca volo, marche, hex o aeroporto',
  searchNoResults: 'Nessun risultato nelle vicinanze o nella rete.',
  searchUpstream: 'Ricerca nella rete…',
  filters: 'Filtri',
  layers: 'Mappa',
  settings: 'Impostazioni',
  about: 'Informazioni e dati',
  close: 'Chiudi',
  aircraft: 'Aerei',
  inView: 'visibili',
  ground: 'A terra',
  altitude: 'Quota',
  geoAltitude: 'Quota GPS',
  speed: 'Velocità al suolo',
  vs: 'Velocità verticale',
  track: 'Rotta',
  squawk: 'Squawk',
  registration: 'Marche',
  type: 'Tipo',
  category: 'Categoria',
  hex: 'ICAO 24 bit',
  source: 'Fonte della posizione',
  positionAge: 'Età della posizione',
  provider: 'Fornitore dei dati',
  route: 'Tratta',
  routeUnknown: 'Nessuna tratta registrata per questo nominativo.',
  routeImplausible: 'Esiste una tratta per questo nominativo, ma non corrisponde alla posizione attuale dell’aereo, quindi è nascosta.',
  routeNote: 'Tratta abituale di questo nominativo (dati della comunità). Non è un orario in tempo reale.',
  follow: 'Segui',
  unfollow: 'Smetti di seguire',
  share: 'Copia link',
  copied: 'Link copiato',
  trail: 'La scia mostra le posizioni ricevute da quando hai iniziato a osservare.',
  emergency: 'Emergenza',
  military: 'Militare',
  noCallsign: 'Senza nominativo',
  zoomIn: 'Ingrandisci per caricare gli aerei di tutta l’area. Viene mostrato solo il centro.',
  stale: 'Dati in tempo reale in ritardo: la rete della comunità sta limitando le richieste o non è disponibile. Vengono mostrate le ultime posizioni note.',
  offline: 'Sei offline. Le posizioni riprenderanno quando tornerà la connessione.',
  loading: 'Caricamento degli aerei in tempo reale…',
  errorData: 'Impossibile raggiungere l’API di Skywake.',
  apiNotConfigured: 'Questa versione non ha un’API di dati in tempo reale configurata, quindi non è possibile mostrare aerei.',
  retry: 'Riprova',
  dataAge: 'Età dei dati',
  providerStatus: 'Stato del fornitore',
  ok: 'OK',
  degraded: 'Degradato',
  theme: 'Tema',
  themeAuto: 'Sistema',
  themeLight: 'Chiaro',
  themeDark: 'Scuro',
  units: 'Unità',
  language: 'Lingua',
  labels: 'Etichette dei nominativi',
  airports: 'Aeroporti',
  trails: 'Scia dell’aereo selezionato',
  colorBy: 'Colora gli aerei per',
  colorAlt: 'Quota',
  colorSource: 'Fonte della posizione',
  altMin: 'Quota min. (ft)',
  altMax: 'Quota max. (ft)',
  speedMin: 'Velocità min. (kt)',
  speedMax: 'Velocità max. (kt)',
  callsignPrefixes: 'Prefissi compagnia / nominativo',
  callsignPrefixesHint: 'Separati da virgole, es. ITY, EZY, RYR',
  types: 'Tipi di aereo',
  typesHint: 'Codici ICAO, * come jolly, es. A32*, B738',
  hideGround: 'Nascondi gli aerei a terra',
  onlyEmergency: 'Solo emergenze (7500/7600/7700)',
  onlyMilitary: 'Solo militari',
  sources: 'Fonti della posizione',
  presets: 'Preimpostazioni salvate',
  presetName: 'Nome della preimpostazione',
  savePreset: 'Salva i filtri attuali',
  apply: 'Applica',
  delete: 'Elimina',
  clearFilters: 'Azzera i filtri',
  filtered: 'filtrati',
  airport: 'Aeroporto',
  elevation: 'Elevazione',
  nearbyTraffic: 'Traffico entro 30 km',
  noNearby: 'Al momento nessun aereo tracciato vicino a questo aeroporto.',
  viewOnOurAirports: 'Vedi su OurAirports',
  bookmarks: 'Segnalibri',
  bookmarkView: 'Salva questa vista',
  watchlist: 'Osserva',
  watching: 'Osservato',
  alerts: 'Avvisi',
  alertsEmergency: 'Avvisami degli squawk di emergenza visibili',
  alertsWatch: 'Avvisami quando compaiono aerei osservati',
  alertsPermissionDenied: 'Le notifiche sono bloccate dal browser. Gli avvisi compariranno solo nell’app.',
  emergencyAlert: 'Squawk di emergenza',
  watchAlert: 'Aereo osservato avvistato',
  adsb: 'ADS-B',
  mlat: 'MLAT',
  tisb: 'TIS-B',
  adsr: 'ADS-R',
  modes: 'Modo S',
  other: 'Altro',
  attribution: 'Dati degli aerei: contributori di ADSB.lol (ODbL 1.0). Tratte: VRS standing data (CC0). Aeroporti: OurAirports (pubblico dominio). Foto: fotografi di Planespotters.net (citati su ogni foto). Meteo: NOAA Aviation Weather Center (pubblico dominio).',
  aboutBody:
    'Skywake è software libero e open source. Le posizioni provengono da ricevitori ADS-B volontari aggregati da ADSB.lol; la copertura dipende da dove i volontari hanno installato i ricevitori. Nessun account, nessuna pubblicità, nessun cookie di tracciamento. Le tue impostazioni restano su questo dispositivo.',
  limitations: 'Limiti noti',
  limitationsList:
    'Ancora nessuno storico né riproduzione: Skywake mostra solo ciò che ha ricevuto da quando l’hai aperto.|Le tratte provengono da un database comunitario di nominativi e possono essere errate o non aggiornate.|La copertura è scarsa sugli oceani e nelle regioni con pochi ricevitori.|Gli aerei i cui proprietari hanno chiesto riservatezza (es. LADD/PIA) possono essere nascosti o anonimizzati.',
  sourceCode: 'Codice sorgente',
  feedData: 'Installa un ricevitore e invia dati ad ADSB.lol',
  version: 'Versione',
  webglMissing: 'Il tuo browser non può disegnare la mappa in tempo reale (WebGL2 non disponibile).',
  selectedOutOfCoverage: 'Questo aereo non è più ricevuto.',
  emergencies: 'Emergenze',
  compare: 'Confronta',
  list: 'Elenco',
  sortBy: 'Ordina per',
  callsign: 'Nominativo',
  locate: 'La mia posizione',
  photoAlt: 'Foto dell’aereo {reg}',
  weather: 'Meteo (METAR)',
  weatherUnavailable: 'Il meteo non è disponibile al momento.',
  weatherNone: 'Questo aeroporto non pubblica METAR.',
  weatherSource: 'NOAA Aviation Weather Center. Non usare per la pianificazione dei voli.',
  wind: 'Vento',
  calm: 'Calma',
  variable: 'Variabile',
  gusts: 'raffiche',
  visibility: 'Visibilità',
  temperature: 'Temp. / punto di rugiada',
  clouds: 'Nubi',
  observed: 'Età del bollettino',
  legFlown: 'percorsi',
  legToGo: 'rimanenti',
  legEta: 'Arrivo',
  legNote: 'Stima ortodromica basata sulla tratta abituale e sulla velocità attuale.',
};
